import { useRef, useState } from "react";
import AIVideoEditorContext from "./aiVideoEditorContext";
import ViewService from "services/ViewService";
import { addNewRow, copyOverlayToDestination, getDefaultDIYStates, getDefaultGlobalStates, getFitOverlaySize, getImageAspectRatioEnum, getTabVisibility, getVideoAspectRatioEnum, Global_Style_Subtitle, handleAddOverlayDIY, handleDeleteOverlayDIY, handleResetOverlay, handleUpdateOverlayDIY, isDIYTemplate } from "views/app-views/vudio/StudioAI/AI_Video_Shoots/V2/AiVideoShootCommonFunction";
import { generateUniqueName } from "views/app-views/vudio/VudioUtils/commonVarible";
import LoadingService from "components/shared-components/Loading/LoadingServices";

function AIVideoEditorProvider({ children }) {
  const [markerLeft, setMarkerLeft] = useState(0);
  const [currentTimeSec, setCurrentTimeSec] = useState(0);
  const [aiVideoShootsStates, setAiVideoShootsStates] = useState({
    job_id: null,
    images: [],
    videos: [],
    selectedTemplate: null,
    templateDuration: 0,
    global_background: null,
    global_text_Configuration: {
      font: null,
      font_style: null,
      font_size: 24,
      color: "#ffffff",
      shadow: false,
    },
    avatars: [],
    avatarDraft: null,
    musics: [],
    brandings: [],
    scripts: [],
    scriptGlobalSubtitle: false,
    texts: [],
    elements: [],
    brolls: [],
    canvas: [],
    shapes: [],
    globalPlatform: "bytedance",
    globalSubtitleConfig: {
      ...Global_Style_Subtitle
    }
  })
  const [showGenericToast, setShowGenericToast] = useState({
    status: false,
    type: "success",
    message: "",
  });
  const [currentItemKey, setCurrentItemKey] = useState("media");
  const [zoomLevel, setZoomLevel] = useState(1);
  const [currentSelectedScriptId, setCurrentSelectedScriptId] = useState(null);
  const [avatarSwitchMode, setAvatarSwitchMode] = useState("creatify");
  const [creditsStates, setCreditsStates] = useState({
    loading: false,
    credits: 0
  })
  const [previewAnimationId, setPreviewAnimationId] = useState(null);
  const speakingImageStates = aiVideoShootsStates?.diy?.global_states?.speakingImageStates ?? {
    uploadedImages: [],
    platform: "veo",
    selectedImage: [],
    characters: [],
    scenePrompt: null,
    veoPromptData: [
      {
        type: "scene",
        dialogue: null,
        image_url: "",
        duration: 8,
        char_position: "center",
        character_image: null,
        character_id: null,
        character_description: null,
        sub_job_id: null,
        video_prompt: "",
        sfx_prompt: "",
        negative_prompt: "",
        show_subtitle: false,
        is_sfx: false,
        is_video_prompt: false
      }
    ],
    veoCharacters: [],
    speakingImagePrompt: {
      ai_mode: {
        prompt: null,
        language: "",
        segmentScript: []
      },
      custom_mode: {
        prompt: null,
        language: "default",
        segmentScript: []
      }
    },
    speakingImgJobId: null,
    speakingImgGeneratedScene: [],
    selectedVoice: {},
    klingPrompt: {
      manual_mode: {
        prompt: ""
      },
      ai_mode: {
        prompt: "",
        language: ""
      }
    },
    klingScript: "",
    showCreateSpeakingImgBtn: false
  };
  // All speaking image states are now accessed through speakingImageStates object
  const [scrollKey, setScrollKey] = useState(null)

  const aiStateRef = useRef();

  const [isGeneratingSpeakingImage, setIsGeneratingSpeakingImg] = useState(false);
  let speakingImgIntervalIdRef = useRef(null);
  const lastGeneratedItemsRef = useRef([]);
  const [speakingImgScriptGenearted, setSpeakingImgScriptGenerated] = useState(false);
  const [charMappingLoader, setCharMappingLoader] = useState(false);
  const characterCounterRef = useRef(1);
  const [editBlockStates, setEditBlockStates] = useState({
    overlayType: null,
    overlayId: null,
    overlayData: null,
    overlayRowIndex: null
  })

  const [aiToolKey, setAIToolKey] = useState(null);


  const [fonts, setFonts] = useState({
    vudio: [],
    custom: []
  })

  const [modelsData, setModelsData] = useState([]);

  const fetchI2VModels = async ()=>{
    try {

      const params = {
        module: "video_shoot"
      }

      const response = await ViewService.getAIModels(params);

      const data = response?.data ?? [];

      setModelsData(data);
      
    } catch (error) {
      setModelsData([])
    }
  }

  const handleUpdatedGlobalStates = (statesType, key, value) => {
    setAiVideoShootsStates((prev) => ({
      ...prev,
      diy: {
        ...prev?.diy,
        global_states: {
          ...prev?.diy?.global_states,
          [statesType]: {
            ...prev?.diy?.global_states[statesType],
            [key]: value
          }
        }
      }
    }))
  }

  // speakingImageStates derived values and setters
  const platform = speakingImageStates?.platform;
  const veoCharacters = speakingImageStates?.veoCharacters ?? [];
  const setVeoCharacters = (value) => handleUpdatedGlobalStates("speakingImageStates", "veoCharacters", value);
  const speakingImagePrompt = speakingImageStates?.speakingImagePrompt ?? {
    ai_mode: { prompt: null, language: "", segmentScript: [] },
    custom_mode: { prompt: null, language: "default", segmentScript: [] }
  };
  const setSpeakingImagePrompt = (value) => handleUpdatedGlobalStates("speakingImageStates", "speakingImagePrompt", value);
  const speakingImgJobId = speakingImageStates?.speakingImgJobId ?? null;
  const setSpeakingImgJobId = (value) => handleUpdatedGlobalStates("speakingImageStates", "speakingImgJobId", value);
  const speakingImgGeneratedScene = speakingImageStates?.speakingImgGeneratedScene ?? [];
  const setSpeakingImgGeneratedScene = (value) => handleUpdatedGlobalStates("speakingImageStates", "speakingImgGeneratedScene", value);
  const selectedVoice = speakingImageStates?.selectedVoice ?? {};
  const setSelectedVoice = (value) => handleUpdatedGlobalStates("speakingImageStates", "selectedVoice", value);
  const klingPrompt = speakingImageStates?.klingPrompt ?? {
    manual_mode: { prompt: "" },
    ai_mode: { prompt: "", language: "" }
  };
  const setKlingPropmt = (value) => handleUpdatedGlobalStates("speakingImageStates", "klingPrompt", value);
  const klingScript = speakingImageStates?.klingScript ?? "";
  const setKlingScript = (value) => handleUpdatedGlobalStates("speakingImageStates", "klingScript", value);
  const setShowCreateSpeakingImgBtn = (value)=> handleUpdatedGlobalStates("speakingImageStates", "showCreateSpeakingImgBtn", value);
  const showCreateSpeakingImgBtn = speakingImageStates?.showCreateSpeakingImgBtn ?? false;

  // product showcase pov states

  const povStates = aiVideoShootsStates?.diy?.global_states?.povStates ?? {
    image_url: null,
    image_in_use_url: null,
    activePanel: ["1"],
    selectedFilmingStyle: null,
    scenes: []
  };

  const handleUpdatePOVStates = (key, value) => {
    handleUpdatedGlobalStates("povStates", key, value);
    if (key == "image_url" || key == "image_in_use_url") {
      if (key == "image_url" && povStates?.image_in_use_url) {
        handleUpdatePOVStates("activePanel", ["2"])
      }
      else if (key == "image_in_use_url" && povStates?.image_url) {
        handleUpdatePOVStates("activePanel", ["2"])
      }
    }
    else if (key == "selectedFilmingStyle") {
      handleUpdatePOVStates("activePanel", ["3"])
    }
  }

  const povIntervalRef = useRef(null);
  const [generatingPOV, setGeneratingPOV] = useState(false);

  const stopPOVPolling = () => {
    if (povIntervalRef.current) {
      clearTimeout(povIntervalRef.current);
    }
  }

  const handleAddPovOverlayBlock = async (id, duration, job_id) => {
    const newOverlay = {
      id,
      status: "GENERATING",
      url: null,
      duration,
      type: "videos",
      width: 1080,
      height: 1930,
      x: 0,
      y: 0,
      isSelected: false,
      rotation: 0,
      isPov: true,
      job_id
    }

    await AddNewDIYOverlayWithMetaData("video", null, "videos", setAiVideoShootsStates, newOverlay, setShowGenericToast, setCurrentTimeSec, setScrollKey);

  }

  const getPOVVideoJobStatus = async (jobsIds = [], jobId, scenes = []) => {
    try {

      const params = {
        job_id: jobId
      }

      const response = await ViewService.getPOVShowcaseVideoJobStatus(params);
      const status = response?.data?.status;

      console.log(status);

      if (status == "SUCCESS" || status == "FINISHED") {
        let updatedScenes = [...scenes];
        for (let job of response?.data?.job) {
          handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { id: job?._id, url: job?.url, status: "SUCCESS", overlayStartTime: 0 }, setShowGenericToast);
          updatedScenes = updatedScenes?.map((sceneData) => {
            if (sceneData?.sub_job_id == job?._id) {
              return {
                ...sceneData,
                status: "SUCCESS"
              }
            }
            else {
              return sceneData;
            }
          })
        }
        handleUpdatePOVStates("scenes", updatedScenes);
        fetchCredits()
        setGeneratingPOV(false);
        deselectAllOverlaysDIY();
        setAiVideoShootsStates((prev) => ({
          ...prev,
          diy: {
            ...prev?.diy,
            overlays: {
              ...prev?.diy?.overlays,
              "videos": {
                ...prev?.diy?.overlays?.videos,
                poll_videos: {
                  "pov": {
                    job_id: prev?.diy?.overlays?.videos?.poll_videos?.pov?.job_id,
                    polling: false
                  }
                }
              }
            }
          }
        }))
      }

      else if (status == "IN-PROGRESS" || status == "PARTIAL" || status == "PENDING" || status == "IMAGE_GENERATION" || status == "GENERATE_VIDEO" || status == "CHECK_GENERATION_STATUS") {
        povIntervalRef.current = setTimeout(() => {
          getPOVVideoJobStatus(jobsIds, jobId, scenes);
        }, 10000)
      }

      else if (status == "PARTIALLY_FAILED") {
        let updatedScenes = [...scenes];
        for (let job of response?.data?.job) {
          if (job?.status == "FAILED") {
            handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { id: job?._id, url: null, status: "ERROR" }, setShowGenericToast)
          }
          else {
            handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { id: job?._id, url: job?.url, status: "SUCCESS" }, setShowGenericToast)
          }
          updatedScenes = updatedScenes?.map((sceneData) => {
            if (sceneData?.sub_job_id == job?._id) {
              return {
                ...sceneData,
                status: job?.status == "FAILED" ? "ERROR" : "SUCCESS"
              }
            }
            else {
              return sceneData;
            }
          })
        }
        handleUpdatePOVStates("scenes", updatedScenes);
        fetchCredits()
        setGeneratingPOV(false);
        deselectAllOverlaysDIY();
        setAiVideoShootsStates((prev) => ({
          ...prev,
          diy: {
            ...prev?.diy,
            overlays: {
              ...prev?.diy?.overlays,
              "videos": {
                ...prev?.diy?.overlays?.videos,
                poll_videos: {
                  "pov": {
                    job_id: prev?.diy?.overlays?.videos?.poll_videos?.pov?.job_id,
                    polling: false
                  }
                }
              }
            }
          }
        }))
      }

      else {
        throw Error("Error in Fetching the Script Duration");
      }

    } catch (error) {
      stopPOVPolling();
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the POV Showcase Video",
        status: true,
        type: "danger"
      })
      setGeneratingPOV(false);
      let updatedScenes = [...scenes];
      jobsIds.forEach((job_id) => {
        handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { status: "ERROR", url: null, id: job_id }, setShowGenericToast)
        updatedScenes = updatedScenes?.map((sceneData) => {
          if (sceneData?.sub_job_id == job_id) {
            return {
              ...sceneData,
              status: "ERROR"
            }
          }
          else {
            return sceneData;
          }
        })
      })
      handleUpdatePOVStates("scenes", updatedScenes);
      setAiVideoShootsStates((prev) => ({
        ...prev,
        diy: {
          ...prev?.diy,
          overlays: {
            ...prev?.diy?.overlays,
            "videos": {
              ...prev?.diy?.overlays?.videos,
              poll_videos: {
                "pov": {
                  job_id: prev?.diy?.overlays?.videos?.poll_videos?.pov?.job_id,
                  polling: false
                }
              }
            }
          }
        }
      }))
    }
  }

  const handleGeneratePOVvideo = async () => {
    try {
      setGeneratingPOV(true);
      const payload = {
        product_image_url: povStates?.image_url,
        product_inuse_image_url: povStates?.image_in_use_url,
        pov_ad_style_id: povStates?.selectedFilmingStyle?._id,
        jobs: povStates?.scenes?.map((sceneData) => {
          return {
            dialogue: sceneData?.dialogue,
            video_prompt: sceneData?.video_prompt,
            sfx_prompt: sceneData?.show_sfx ? sceneData?.sfx_prompt : null,
            negative_prompt: sceneData?.negative_prompt,
            duration: sceneData?.duration,
            category: sceneData?.category
          }
        })
      }

      const response = await ViewService.createPOVShowcaseVideoJob(payload);

      const job_id = response?.data?.job_id;

      const jobResponse = await ViewService.getPOVShowcaseVideoJobStatus({ job_id });

      const jobs = jobResponse?.data?.job ?? [];

      let jobsCount = 0;
      let updatedScenes = [];

      for (let job of jobs) {
        await handleAddPovOverlayBlock(job?._id, job?.duration, job_id);
        const currentScene = povStates?.scenes[jobsCount++];
        updatedScenes.push({
          ...currentScene,
          status: "GENERATING",
          sub_job_id: job?._id,
          job_id: job_id
        })
      }

      handleUpdatePOVStates("scenes", updatedScenes);

      getPOVVideoJobStatus(jobs?.map((jobData) => jobData?._id), job_id, updatedScenes);

      setAiVideoShootsStates((prev) => ({
        ...prev,
        diy: {
          ...prev?.diy,
          overlays: {
            ...prev?.diy?.overlays,
            "videos": {
              ...prev?.diy?.overlays?.videos,
              poll_videos: {
                "pov": {
                  job_id: job_id,
                  polling: true
                }
              }
            }
          }
        }
      }))

    } catch (error) {
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the Video",
        status: true,
        type: "danger"
      })
      setGeneratingPOV(false);
      setAiVideoShootsStates((prev) => ({
        ...prev,
        diy: {
          ...prev?.diy,
          overlays: {
            ...prev?.diy?.overlays,
            "videos": {
              ...prev?.diy?.overlays?.videos,
              poll_videos: {
                "pov": {
                  job_id: prev?.diy?.overlays?.videos?.poll_videos?.pov?.job_id,
                  polling: false
                }
              }
            }
          }
        }
      }))
    }
  }

  const handleRegeneratePOVVideo = async (sceneData) => {
    if(!sceneData?.job_id && !sceneData?.sub_job_id){
      setShowGenericToast({
        message: "Error in Regenerating the Video",
        status: true,
        type: "danger"
      })
      return;
    }
    try {
      setGeneratingPOV(true);

      const payload = {
        job_id: sceneData?.job_id,
        regen_array: [{
          sub_job_id: sceneData?.sub_job_id,
          dialogue: sceneData?.dialogue,
          video_prompt: sceneData?.video_prompt,
          sfx_prompt: sceneData?.show_sfx ? sceneData?.sfx_prompt : null,
          negative_prompt: sceneData?.negative_prompt,
          duration: sceneData?.duration,
          category: sceneData?.category
        }]
      }

      await ViewService.regenPOVShowcaseVideoJob(payload);

      let currentScenes = [...povStates?.scenes];

      currentScenes = currentScenes.map((scene)=>{
        if(scene?.sub_job_id == sceneData?.sub_job_id){
          return {
            ...scene,
            status: "GENERATING"
          }
        }
        else{
          return scene
        }
      })

      handleUpdatePOVStates("scenes", currentScenes);

      handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { status: "GENERATING", url: null, id: sceneData?.sub_job_id }, setShowGenericToast)

      getPOVVideoJobStatus([sceneData?.sub_job_id], sceneData?.job_id, currentScenes);

      setAiVideoShootsStates((prev) => ({
        ...prev,
        diy: {
          ...prev?.diy,
          overlays: {
            ...prev?.diy?.overlays,
            "videos": {
              ...prev?.diy?.overlays?.videos,
              poll_videos: {
                "pov": {
                  job_id: sceneData?.job_id,
                  polling: true
                }
              }
            }
          }
        }
      }))

    } catch (error) {
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Regenerating the Video",
        status: true,
        type: "danger"
      })
      setGeneratingPOV(false);
      setAiVideoShootsStates((prev) => ({
        ...prev,
        diy: {
          ...prev?.diy,
          overlays: {
            ...prev?.diy?.overlays,
            "videos": {
              ...prev?.diy?.overlays?.videos,
              poll_videos: {
                "pov": {
                  job_id: sceneData?.job_id,
                  polling: false
                }
              }
            }
          }
        }
      }))
    }
  }
  

  // clone an ad states
  const [cloneAdStates, setCloneAdStates] = useState({
    prompt: null,
    duration: 5,
    image_url: null,
    video_url: null,
    activePanel: ["1"],
    scenes: []
  })

  const [generatingCloneAdScripts, setGeneratingCloneAdScripts] = useState(false);
  const [generatedScenesStatesCloneAd, setGeneratedScenesStatesCloneAd] = useState({
    showModal: false,
    scenes: []
  })

  const handleUpdateCloneAdStates = (key, value) => {
    setCloneAdStates((prev) => ({
      ...prev,
      [key]: value
    }))
  }

  const handleUpdatedScenesCloneAd = (data = []) => {
    let scenes = [];
    data.forEach((scene) => {
      const data = {
        _id: generateUniqueName(2),
        duration: scene?.duration_seconds,
        dialogue: scene?.dialogue,
        image_prompt: scene?.image_prompt,
        video_prompt: scene?.video_prompt,
        negative_prompt: scene?.negative_prompt,
        sfx_prompt: scene?.sfx_prompt,
        show_sfx: true,
        image_url: scene?.image_url ?? cloneAdStates?.image_url,
        show_continuity: true
      }
      scenes.push(data);
    })
    setGeneratedScenesStatesCloneAd({
      showModal: true,
      scenes
    })
  }

  const fetchJobStatusCloneAdScripts = async (jobId) => {
    try {

      const params = {
        job_id: jobId
      }

      const response = await ViewService.getGenerateScriptCreateAdJobStatus(params);

      const status = response?.data?.status;

      if (status == "FINISHED") {
        const scripts = response?.data?.segmented_script?.segments || [];
        setGeneratingCloneAdScripts(false);
        handleUpdatedScenesCloneAd(scripts);
      }
      else if (status == "FAILED") {
        throw new Error("Error in Generating the Scripts");
      }
      else {
        setTimeout(() => {
          fetchJobStatusCloneAdScripts(jobId);
        }, 10000)
      }

    } catch (error) {
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the Scripts",
        status: true,
        type: "danger"
      })
      setGeneratingCloneAdScripts(false);
    }
  }

  const handleGenerateScriptsCloneAd = async () => {
    try {
      setGeneratingCloneAdScripts(true);

      const payload = {
        prompt: cloneAdStates?.prompt ?? null,
        duration: Number(cloneAdStates?.duration) ?? 5,
        image_url: cloneAdStates?.image_url ?? null,
        video_url: cloneAdStates?.video_url
      }

      const response = await ViewService.createGenerateScriptCloneAdJob(payload);

      const jobId = response?.data?.job_id;

      fetchJobStatusCloneAdScripts(jobId)

    } catch (error) {
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the Scripts",
        status: true,
        type: "danger"
      })
      setGeneratingCloneAdScripts(false);
    }
  }

  const resetCloneAdStates = () => {
    setCloneAdStates({
      prompt: null,
      duration: 5,
      image_url: null,
      video_url: null,
      activePanel: ["1"],
      scenes: []
    })
    setGeneratedScenesStatesCloneAd({
      showModal: false,
      scenes: []
    })
    setGeneratingCloneAdScripts(false)
  }

  const cloneAdIntervalRef = useRef(null);
  const [generatingCloneAd, setGeneratingCloneAd] = useState(false);

  const stopCloneAdPolling = () => {
    if (cloneAdIntervalRef.current) {
      clearTimeout(cloneAdIntervalRef.current);
    }
  }

  const handleAddCloneAdOverlayBlock = async (id, duration) => {
    const newOverlay = {
      id,
      status: "GENERATING",
      url: null,
      duration,
      type: "videos",
      width: 1080,
      height: 1930,
      x: 0,
      y: 0,
      isSelected: false,
      rotation: 0,
    }

    await AddNewDIYOverlayWithMetaData("video", null, "videos", setAiVideoShootsStates, newOverlay, setShowGenericToast, setCurrentTimeSec, setScrollKey);
  }

  const getCreateVideoJobStatusCloneAd = async (jobsIds = [], jobId) => {
    try {

      const params = {
        job_id: jobId
      }

      const response = await ViewService.fetchSpeakingImageJob(params);
      const status = response?.data?.[0]?.status;
      const jobStatusList = response?.data?.[0]?.job_status;

      if (status == "FINISHED") {
        for (let job of jobStatusList) {
          handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { id: job?._id, url: job?.url, status: "SUCCESS" }, setShowGenericToast)
        }
        fetchCredits()
        setGeneratingCloneAd(false);
        deselectAllOverlaysDIY();
      }

      else if (status == "PARTIALLY_FAILED") {
        for (let job of jobStatusList) {
          if (job?.status == "FAILED") {
            handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { id: job?._id, url: null, status: "ERROR" }, setShowGenericToast)
          }
          else {
            handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { id: job?._id, url: job?.url, status: "SUCCESS" }, setShowGenericToast)
          }
        }
        fetchCredits()
        setGeneratingCloneAd(false);
        deselectAllOverlaysDIY();
      }
      
      else if(status == "FAILED") {
        throw Error("Error in Fetching the Script Duration");
      }

      else{
        cloneAdIntervalRef.current = setTimeout(() => {
          getCreateVideoJobStatusCloneAd(jobsIds, jobId);
        }, 10000)
      }


    } catch (error) {
      stopCloneAdPolling();
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the POV Showcase Video",
        status: true,
        type: "danger"
      })
      setGeneratingCloneAd(false);
      jobsIds.forEach((job_id) => {
        handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { status: "ERROR", url: null, id: job_id }, setShowGenericToast)
      })
    }
  }

  const handleGenerateCloneAdvideo = async () => {
    try {
      setGeneratingCloneAd(true);
      const payload = {
        prompt: cloneAdStates?.prompt,
        image_url: cloneAdStates?.image_url,
        platform: "veo",
        speaking_image_jobs: cloneAdStates?.scenes?.map((sceneData) => {
          return {
            image_url: sceneData?.image_url,
            duration: sceneData?.duration,
            aspect_ratio: "9:16",
            sfx: sceneData?.show_sfx,
            dialogue: sceneData?.dialogue,
            character_description: null,
            sfx_prompt: sceneData?.show_sfx ? sceneData?.sfx_prompt : null,
            veo_prompt: sceneData?.video_prompt,
            negative_prompt: sceneData?.negative_prompt,
            bridge_block: false,
            continuity: sceneData?.show_continuity
          }
        })
      }

      const response = await ViewService.generateSpeakingVideo(payload);

      const job_id = response?.data?._id;

      const jobResponse = await ViewService.fetchSpeakingImageJob({ job_id });

      const jobs = jobResponse?.data?.[0]?.job_status ?? [];

      for (let job of jobs) {
        await handleAddCloneAdOverlayBlock(job?._id, job?.duration);
      }

      let currentScenesData = [...cloneAdStates?.scenes];

      for (let i = 0; i < jobs?.length; i++) {
        currentScenesData[i] = {
          ...currentScenesData[i],
          _id: jobs[i]?._id
        }
      }

      handleUpdateCloneAdStates("scenes", currentScenesData);

      getCreateVideoJobStatusCloneAd(jobs?.map((jobData) => jobData?._id), job_id);

    } catch (error) {
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the Video",
        status: true,
        type: "danger"
      })
      setGeneratingCloneAd(false);
    }
  }

  // create an ad states
  const createAdStates = aiVideoShootsStates?.diy?.global_states?.createAdStates ?? {
    ...getDefaultGlobalStates()?.createAdStates
  }

  const [generating, setGenerating] = useState(false);
  const [generatedScenesStates, setGeneratedScenesStates] = useState({
    showModal: false,
    scenes: []
  })

  const handleUpdateCreateAdStates = (key, value) => {
    handleUpdatedGlobalStates("createAdStates", key, value)
  }

  const handleUpdatedScenes = (data = []) => {
    let scenes = [];
    data.forEach((scene) => {
      const data = {
        _id: generateUniqueName(2),
        duration: scene?.duration_seconds,
        dialogue: scene?.dialogue,
        image_prompt: scene?.image_prompt,
        video_prompt: scene?.video_prompt,
        negative_prompt: scene?.negative_prompt,
        sfx_prompt: scene?.sfx_prompt,
        show_sfx: createAdStates?.sfx,
        image_url: scene?.image_url ?? createAdStates?.image_url,
        audio_url: scene?.audio_url,
        show_continuity: true
      }
      scenes.push(data);
    })
    setGeneratedScenesStates({
      showModal: true,
      scenes
    })
  }

  const fetchJobStatusCreateAdScripts = async (jobId) => {
    try {

      const params = {
        job_id: jobId
      }

      const response = await ViewService.getGenerateScriptCreateAdJobStatus(params);

      const status = response?.data?.status;

      if (status == "FINISHED") {
        const scripts = response?.data?.segmented_script?.segments || [];
        setGenerating(false);
        handleUpdatedScenes(scripts);
      }
      else if (status == "FAILED") {
        throw new Error("Error in Generating the Scripts");
      }
      else {
        setTimeout(() => {
          fetchJobStatusCreateAdScripts(jobId);
        }, 10000)
      }

    } catch (error) {
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the Scripts",
        status: true,
        type: "danger"
      })
      setGenerating(false);
    }
  }

  const handleGenerateScriptsCreateAd = async () => {
    try {
      setGenerating(true);

      const payload = {
        language: createAdStates?.language,
        image_url: createAdStates?.image_url,
        sfx: createAdStates?.sfx,
        voice_id: createAdStates?.voice?.voice_id,
        music_url: createAdStates?.music?.s3_url
      }

      if(createAdStates?.promptType == "ai"){
        payload.type = "CREATE_AD";
        payload.prompt = createAdStates?.prompt;
        payload.duration = createAdStates?.duration;
      }
      else{
        payload.type = "CLONE_AD";
        payload.video_url = createAdStates?.video_url;
        payload.product_url = createAdStates?.product_url;
      }

      const response = await ViewService.createGenerateScriptCreateAdJobV2(payload);

      const jobId = response?.data?.job_id;

      fetchJobStatusCreateAdScripts(jobId)

    } catch (error) {
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the Scripts",
        status: true,
        type: "danger"
      })
      setGenerating(false);
    }
  }

  const resetCreateAdStates = () => {
    setAiVideoShootsStates((prev) => ({
      ...prev,
      diy: {
        ...prev?.diy,
        global_states: {
          ...prev?.diy?.global_states,
          createAdStates: {
            ...getDefaultGlobalStates()?.createAdStates
          }
        }
      }
    }))
    setGeneratedScenesStates({
      showModal: false,
      scenes: []
    })
    setGenerating(false)
  }

  const createAdIntervalRef = useRef(null);
  const [generatingCreateAd, setGeneratingCreateAd] = useState(false);

  const stopCreateAdPolling = () => {
    if (createAdIntervalRef.current) {
      clearTimeout(createAdIntervalRef.current);
    }
  }

  const handleAddCreateAdOverlayBlock = async (id, duration) => {
    const newOverlay = {
      id,
      status: "GENERATING",
      url: null,
      duration,
      type: "videos",
      width: 1080,
      height: 1930,
      x: 0,
      y: 0,
      isSelected: false,
      rotation: 0,
    }

    await AddNewDIYOverlayWithMetaData("video", null, "videos", setAiVideoShootsStates, newOverlay, setShowGenericToast, setCurrentTimeSec, setScrollKey);
  }

  const getCreateVideoJobStatus = async (jobsIds = [], jobId) => {
    try {

      const params = {
        job_id: jobId
      }

      const response = await ViewService.fetchCreateAdJob(params);
      const status = response?.data?.[0]?.status;
      const jobStatusList = response?.data?.[0]?.job_status;

      if (status == "FINISHED") {
        addNewRow(setAiVideoShootsStates, "music");
        for (let job of jobStatusList) {
          handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { id: job?._id, url: job?.url, status: "SUCCESS" }, setShowGenericToast)
          copyOverlayToDestination("videos", "music", job?._id, {music: {s3_url: job?.audio_url, name: `Content_style_ad_${generateUniqueName(4)}`}, speed: 1, volume: 100, isSelected: false}, setAiVideoShootsStates)
        }
        fetchCredits()
        setGeneratingCreateAd(false);
        deselectAllOverlaysDIY();
      }

      else if (status == "PARTIALLY_FAILED") {
        addNewRow(setAiVideoShootsStates, "music");
        for (let job of jobStatusList) {
          if (job?.status == "FAILED") {
            handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { id: job?._id, url: null, status: "ERROR" }, setShowGenericToast)
          }
          else {
            handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { id: job?._id, url: job?.url, status: "SUCCESS" }, setShowGenericToast)
            copyOverlayToDestination("videos", "music", job?._id, {music: {s3_url: job?.audio_url, name: `Content_style_ad_${generateUniqueName(4)}`}, speed: 1, volume: 100, isSelected: false}, setAiVideoShootsStates)
          }
        }
        fetchCredits()
        setGeneratingCreateAd(false);
        deselectAllOverlaysDIY();
      }

      else if (status == "FAILED") {
        throw Error("Error in Fetching the Script Duration");
      }

      else {
        createAdIntervalRef.current = setTimeout(() => {
          getCreateVideoJobStatus(jobsIds, jobId);
        }, 10000)
      }


    } catch (error) {
      stopCreateAdPolling();
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the POV Showcase Video",
        status: true,
        type: "danger"
      })
      setGeneratingCreateAd(false);
      jobsIds.forEach((job_id) => {
        handleUpdateOverlayDIY("videos", setAiVideoShootsStates, { status: "ERROR", url: null, id: job_id }, setShowGenericToast)
      })
    }
  }

  const handleGenerateCreateAdvideo = async () => {
    try {
      setGeneratingCreateAd(true);
      const payload = {
        ad_jobs: createAdStates?.scenes?.map((sceneData) => {
          return {
            image_url: sceneData?.image_url,
            voice_id: createAdStates?.voice?.voice_id,
            duration: sceneData?.duration,
            aspect_ratio: "9:16",
            sfx: sceneData?.show_sfx,
            dialogue: sceneData?.dialogue,
            character_description: null,
            sfx_prompt: sceneData?.show_sfx ? sceneData?.sfx_prompt : null,
            video_prompt: sceneData?.video_prompt,
            negative_prompt: sceneData?.negative_prompt,
            continuity: sceneData?.show_continuity,
            audio_url: sceneData?.audio_url
          }
        })
      }

      const response = await ViewService.generateCreateAdJob(payload);

      const job_id = response?.data?.job_id;

      const jobResponse = await ViewService.fetchCreateAdJob({ job_id });

      const jobs = jobResponse?.data?.[0]?.job_status ?? [];

      for (let job of jobs) {
        await handleAddCreateAdOverlayBlock(job?._id, job?.duration);
      }

      let currentScenesData = [...createAdStates?.scenes];

      for (let i = 0; i < jobs?.length; i++) {
        currentScenesData[i] = {
          ...currentScenesData[i],
          _id: jobs[i]?._id
        }
      }

      handleUpdateCreateAdStates("scenes", currentScenesData);

      getCreateVideoJobStatus(jobs?.map((jobData) => jobData?._id), job_id);

    } catch (error) {
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the Video",
        status: true,
        type: "danger"
      })
      setGeneratingCreateAd(false);
    }
  }

  //scripts


  const [localScripts, setLocalScripts] = useState([]);
  const scriptIntervalRef = useRef(null);
  const [generatingScripts, setGeneratingScripts] = useState(false);


  const getFonts = async () => {
    try {

      const response = await ViewService.getCompanyFonts();

      const data = response?.data || [];

      const vudio_fonts = data?.filter((fontData) => fontData?.type != "custom");
      const custom_fonts = data?.filter((fontData) => fontData?.type == "custom");

      setFonts({
        vudio: vudio_fonts,
        custom: custom_fonts
      })

    } catch (error) {
      setFonts({
        vudio: [],
        custom: []
      })
    }
  }

  const stopScriptPolling = () => {
    if (scriptIntervalRef.current) {
      clearTimeout(scriptIntervalRef.current);
    }
  }

  const getScriptsDurationPayload = () => {
    let scripts = [];
    localScripts?.map((scriptData) => {
      if (scriptData?.type == "script" && !scriptData?.audio_url) {
        let scriptConfig = {
          script: scriptData?.script,
          script_id: scriptData?.id,
          voice_id: scriptData?.voice?.voice_id
        }
        scripts.push(scriptConfig);
      }
    })
    return scripts;
  }

  const handleUpdateScriptsDIY = (scripts = []) => {
    let totalScriptDuration = 0;
    const updatedScripts = scripts?.map((scriptData) => {
      const updatedData = {
        ...scriptData,
        startTime: totalScriptDuration,
        endTime: totalScriptDuration + (scriptData?.endTime - scriptData?.startTime),
        status: scriptData?.type == "pause" ? "SUCCESS" : scriptData?.status || "SUCCESS"
      }
      totalScriptDuration = totalScriptDuration + (scriptData?.endTime - scriptData?.startTime);
      return updatedData
    })
    setAiVideoShootsStates((prev) => {
      let undoList = prev?.diy?.undo || [];
      for (let script of updatedScripts) {
        undoList = undoList.filter((undoData) => undoData?.overlayData?.id != script?.id);
      }
      for (let script of updatedScripts) {
        const newUndoAction = {
          action: "ADD",
          overlayKey: "scripts",
          overlayData: {
            ...script,
            isSelected: false
          },
          overlayRowIndex: 0
        }
        undoList.push(newUndoAction);
      }
      return {
        ...prev,
        diy: {
          ...prev?.diy,
          templateDuration: Math.max(prev?.diy?.templateDuration, totalScriptDuration),
          overlays: {
            ...prev?.diy?.overlays,
            "scripts": {
              ...prev?.diy?.overlays["scripts"],
              data: [
                {
                  ...prev?.diy?.overlays["scripts"]?.data[0],
                  data: updatedScripts
                }
              ]
            }
          },
          undo: undoList,
          redo: []
        }
      }
    })
    setLocalScripts(updatedScripts);
  }

  const handleUpdateLocalScriptsDIY = (scripts = []) => {
    let totalScriptDuration = 0;
    const updatedScripts = scripts?.map((scriptData) => {
      const updatedData = {
        ...scriptData,
        startTime: totalScriptDuration,
        endTime: totalScriptDuration + (scriptData?.endTime - scriptData?.startTime),
        status: scriptData?.type == "pause" ? "SUCCESS" : scriptData?.status || "SUCCESS"
      }
      totalScriptDuration = totalScriptDuration + (scriptData?.endTime - scriptData?.startTime);
      return updatedData
    })
    setLocalScripts(updatedScripts);
  }

  const getScriptDurationData = async (scriptsPayload = [], jobId) => {
    try {

      const params = {
        job_id: jobId
      }

      const response = await ViewService.fetchScriptDurationFromJobId(params);

      if (response?.data?.status == "SUCCESS") {
        const scriptsResponse = response?.data?.data?.scripts || [];
        const updatedScriptsPayload = [];
        for (let scriptData of localScripts) {
          const script = scriptsResponse.find((script) => script?.script_id == scriptData?.id);
          if (script) {
            const scriptDuration = script?.duration || 0;
            const updatedSciptData = {
              ...scriptData,
              endTime: scriptData?.startTime + scriptDuration,
              audio_url: script?.audio_url,
              status: "SUCCESS",
              actualDuration: scriptDuration,
              speed: 1
            }
            updatedScriptsPayload.push(updatedSciptData);
          }
          else {
            updatedScriptsPayload.push(scriptData);
          }
        }
        handleUpdateScriptsDIY(updatedScriptsPayload);
        fetchCredits()
        setGeneratingScripts(false);
        deselectAllOverlaysDIY();
      }

      else if (response?.data?.status == "IN-PROGRESS" || response?.data?.status == "PARTIAL") {
        scriptIntervalRef.current = setTimeout(() => {
          getScriptDurationData(scriptsPayload, jobId);
        }, 10000)
      }

      else {
        throw Error("Error in Fetching the Script Duration");
      }

    } catch (error) {
      stopScriptPolling();
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the Scripts Audio",
        status: true,
        type: "danger"
      })
      setGeneratingScripts(false);
      const scriptsIds = scriptsPayload?.map((scriptData) => scriptData?.script_id);
      const updatedScriptsPayload = localScripts?.map((scriptData) => {
        if (scriptsIds.includes(scriptData?.id)) {
          return {
            ...scriptData,
            actualDuration: null,
            status: "ERROR"
          }
        }
        else {
          return scriptData
        }
      })
      handleUpdateScriptsDIY(updatedScriptsPayload);
    }
  }

  const handleGenerateScriptsAudio = async () => {
    try {
      const scriptsPayload = getScriptsDurationPayload();
      if (scriptsPayload.length == 0) {
        handleUpdateScriptsDIY(localScripts);
      }
      else {
        setGeneratingScripts(true);
        const payload = {
          job_id: aiVideoShootsStates?.job_id,
          platform: "eleven-labs",
          scripts: scriptsPayload
        }

        const scriptsIds = scriptsPayload?.map((scriptData) => scriptData?.script_id);
        const updatedScriptsPayload = localScripts?.map((scriptData) => {
          if (scriptsIds.includes(scriptData?.id)) {
            return {
              ...scriptData,
              status: "GENERATING",
              overlayStartTime: 0
            }
          }
          else {
            return scriptData
          }
        })
        handleUpdateScriptsDIY(updatedScriptsPayload);

        const response = await ViewService.getScriptDurationJobId(payload);

        getScriptDurationData(scriptsPayload, response?.data?._id);

      }
    } catch (error) {
      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Generating the Scripts Audio",
        status: true,
        type: "danger"
      })
      setGeneratingScripts(false);
      const scriptsPayload = getScriptsDurationPayload();
      const scriptsIds = scriptsPayload?.map((scriptData) => scriptData?.script_id);
      const updatedScriptsPayload = localScripts?.map((scriptData) => {
        if (scriptsIds.includes(scriptData?.id)) {
          return {
            ...scriptData,
            status: "ERROR",
            actualDuration: null,
            speed: 1
          }
        }
        else {
          return scriptData
        }
      })
      handleUpdateScriptsDIY(updatedScriptsPayload);
    }
  }

  const handleRegenerateScript = async (scriptData = {}) => {
    if (scriptIntervalRef.current) {
      setShowGenericToast({
        message: "Other Scripts are generating",
        status: true,
        type: "error"
      })
      return;
    }
    else {
      try {

        setGeneratingScripts(true);
        const scriptsPayload = [
          {
            script: scriptData?.script,
            script_id: scriptData?.id,
            voice_id: scriptData?.voice?.voice_id
          }
        ]
        const payload = {
          job_id: aiVideoShootsStates?.job_id,
          platform: "eleven-labs",
          scripts: scriptsPayload
        }

        const response = await ViewService.getScriptDurationJobId(payload);

        getScriptDurationData(scriptsPayload, response?.data?._id);

        const scriptsIds = scriptsPayload?.map((scriptData) => scriptData?.id);
        const updatedScriptsPayload = localScripts?.map((scriptData) => {
          if (scriptsIds.includes(scriptData?.id)) {
            return {
              ...scriptData,
              status: "GENERATING"
            }
          }
          else {
            return scriptData
          }
        })
        handleUpdateScriptsDIY(updatedScriptsPayload);

      } catch (error) {
        setShowGenericToast({
          message: error?.response?.data?.message || "Error in Generating the Scripts Audio",
          status: true,
          type: "danger"
        })
        setGeneratingScripts(false);
      }
    }
  }

  //image to video diy polling states

  const imgToVideoIntervalRefs = useRef([]);
  const [creatingJob, setCreatingJob] = useState(false);
  const [ImageToVideoStates, setImageToVideoStates] = useState({
    tab: "single",
    type: "add",
    global: {
      duration: 5,
      platform: "bytedance",
      mode: "std",
      resolution: "720p",
      aspect_ratio: null,
      model_id: "Seeddance1.0Lite",
      model_config_id: "seeddance_1_0_lite_720"
    },
    frames: [{
      frame_id: null,
      image_url: null,
      last_frame_url: null,
      prompt: null,
      sample_video: null,
      aspect_ratio: null,
      platform: "bytedance",
      duration: 5,
      mode: "std",
      resolution: "720p",
      pair_type: null,
      model_id: "Seeddance1.0Lite",
      model_config_id: "seeddance_1_0_lite_720"
    }]
  })

  const stopAllImageToVideoPolling = () => {
    if (imgToVideoIntervalRefs.current) {
      const currentIntervals = imgToVideoIntervalRefs.current || [];
      for (let intervalId of currentIntervals) {
        clearInterval(intervalId);
      }
      imgToVideoIntervalRefs.current = [];
    }
  }

  const stopImageToVideoPolling = (intervalId) => {
    if (imgToVideoIntervalRefs.current) {
      const currentIntervals = imgToVideoIntervalRefs.current || [];
      clearInterval(intervalId);
      const updatedIntervals = currentIntervals.filter((interval) => interval != intervalId);
      imgToVideoIntervalRefs.current = updatedIntervals;
    }
  }

  const addImageToVideoPolling = (intervalId) => {
    if (intervalId) {
      const currentIntervals = imgToVideoIntervalRefs.current || [];
      if (!currentIntervals.includes(intervalId)) {
        imgToVideoIntervalRefs.current = [...currentIntervals, intervalId];
      }
    }
  }

  const handleAddImageToVideoOverlayBlock = (frameData = {}) => {
    const newImageToVideoOverlay = {
      id: frameData?.iv_uuid,
      x: 0,
      y: 0,
      isSelected: false,
      rotation: 0,
      url: null,
      image_url: frameData?.image_url ?? null,
      last_frame_url: frameData?.last_frame_url ?? null,
      mode: frameData?.mode ?? "std",
      aspect_ratio: frameData?.aspect_ratio,
      resolution: frameData?.resolution ?? "720p",
      platform: frameData?.platform ?? "kling",
      duration: frameData?.duration ?? 5,
      prompt: frameData?.prompt ?? null,
      pair_type: frameData?.pair_type ?? null,
      class_type: frameData?.class_type ?? null,
      sample_video: frameData?.sample_video ?? null,
      status: "GENERATING",
      polling_job_id: frameData?.polling_job_id,
      actualDuration: frameData?.duration ?? 5,
      model_id: frameData?.model_id,
      model_config_id: frameData?.model_config_id
    }
    const sizeConfig = getFitOverlaySize(aiVideoShootsStates?.diy?.canvas_ratio || "9:16", newImageToVideoOverlay?.aspect_ratio ?? "9:16");
    let currentData = {
      ...newImageToVideoOverlay
    }
    currentData.x = sizeConfig?.x;
    currentData.y = sizeConfig?.y;
    currentData.height = sizeConfig?.height;
    currentData.width = sizeConfig?.width;
    currentData.currentFit = "fit";
    currentData.flip = "none";
    currentData.overlayStartTime = 0
    handleAddOverlayDIY("img_to_video", setAiVideoShootsStates, currentData, setShowGenericToast, setCurrentTimeSec, setScrollKey, true);
  }

  const handleUpdateImageToVideo = (updatedData = {}) => {
    handleUpdateOverlayDIY("img_to_video", setAiVideoShootsStates, updatedData, setShowGenericToast);
  }

  const pollImageToVideo = async (jobId, framesData = []) => {
    let intervalId = null;

    const checkImageToVideoStatus = async () => {
      try {
        const params = {
          job_id: jobId
        }

        const response = await ViewService.getImageToVideosJob(params);
        const status = response?.data?.status;
        const jobResponseData = response?.data?.job_status;

        if (status == "FINISHED") {
          if (intervalId) {
            stopImageToVideoPolling(intervalId);
          }
          deselectAllOverlaysDIY();
          for (const job of jobResponseData) {
            if (job?.status == "SUCCEEDED" && job?.url) {
              handleUpdateImageToVideo({ id: job?.iv_uuid, url: job?.url, status: "SUCCEEDED", isSelected: false, polling_job_id: null, polling_job_sub_id: null });
            }
            else {
              handleUpdateImageToVideo({ id: job?.iv_uuid, url: null, status: "ERROR", polling_job_id: null, polling_job_sub_id: null })
            }
          }
          fetchCredits();
          setShowGenericToast({
            status: true,
            type: "success",
            message: "Image to Videos Generated Successfully.",
          });
        }
        else if (status == "PARTIALLY_FAILED") {
          if (intervalId) {
            stopImageToVideoPolling(intervalId);
          }
          deselectAllOverlaysDIY();
          for (const job of jobResponseData) {
            if (job?.status == "SUCCEEDED" && job?.url) {
              handleUpdateImageToVideo({ id: job?.iv_uuid, url: job?.url, status: "SUCCEEDED", isSelected: false, polling_job_id: null, polling_job_sub_id: null });
            }
            else {
              handleUpdateImageToVideo({ id: job?.iv_uuid, url: null, status: "ERROR", polling_job_id: null, polling_job_sub_id: null })
            }
          }
          fetchCredits();
          setShowGenericToast({
            status: true,
            type: "danger",
            message: "Some videos generated successfully, but others failed.",
          });
        }
        else if (status == "FAILED") {
          if (intervalId) {
            stopImageToVideoPolling(intervalId);
          }
          deselectAllOverlaysDIY();
          for (const job of jobResponseData) {
            handleUpdateImageToVideo({ id: job?.iv_uuid, url: null, status: "ERROR", polling_job_id: null, polling_job_sub_id: null })
          }
          setShowGenericToast({
            status: true,
            type: "danger",
            message: "Failed to create Image to Video",
          });
        }
        else {
          for (const job of jobResponseData) {
            handleUpdateImageToVideo({ id: job?.iv_uuid, polling_job_sub_id: job?._id });
          }
        }

      } catch (error) {
        if (intervalId) {
          stopImageToVideoPolling(intervalId);
        }
        setShowGenericToast({
          message: error?.response?.data?.message || "Failed to create Image to Video",
          status: true,
          type: "danger"
        })
        for (const job of framesData) {
          handleUpdateImageToVideo({ id: job?.iv_uuid, url: null, status: "ERROR", polling_job_id: null, polling_job_sub_id: null })
        }
      }
    }

    checkImageToVideoStatus();

    intervalId = setInterval(checkImageToVideoStatus, 15000);
    addImageToVideoPolling(intervalId);
  }

  const AddImageToVideos = async (frames = []) => {
    try {
      setCreatingJob(true);
      const payload = {
        jobs: frames.map((frameData) => {
          const framePayload = {
            iv_uuid: generateUniqueName(2),
            image_url: frameData?.image_url ?? null,
            last_frame_url: frameData?.last_frame_url ?? null,
            mode: frameData?.mode ?? "std",
            aspect_ratio: frameData?.aspect_ratio ?? "adaptive",
            resolution: frameData?.resolution ?? "720p",
            platform: frameData?.platform ?? "kling",
            duration: frameData?.duration ?? 5,
            prompt: frameData?.prompt ?? null,
            pair_type: frameData?.pair_type ?? null,
            class_type: frameData?.class_type ?? null,
            model_id: frameData?.model_id,
            model_config_id: frameData?.model_config_id
          }
          return framePayload;
        })
      }

      const response = await ViewService.createImageToVideosJob(payload);

      const jobId = response?.data?.job_id;

      const currentFramesPayload = payload?.jobs || [];
      for (let i = 0; i < frames.length; i++) {
        const newFrameData = {
          ...currentFramesPayload[i],
          ...frames[i],
          polling_job_id: jobId,
        }
        handleAddImageToVideoOverlayBlock(newFrameData);
      }

      pollImageToVideo(jobId, currentFramesPayload);

    } catch (error) {

      setShowGenericToast({
        message: error?.response?.data?.message || "Error in Creating the Image To Video",
        status: true,
        type: "danger"
      })

    } finally {
      setCreatingJob(false);
      setImageToVideoStates({
        ...ImageToVideoStates,
        frames: ImageToVideoStates?.tab == "multi" ? [] : [
          {
            frame_id: null,
            image_url: null,
            last_frame_url: null,
            prompt: null,
            sample_video: null,
            aspect_ratio: null,
            platform: "bytedance",
            duration: 5,
            mode: "std",
            resolution: "720p",
            pair_type: null,
            model_id: "Seeddance1.0Lite",
            model_config_id: "seeddance_1_0_lite_720"
          }
        ],
        type: "add"
      })
    }
  }

  const handleRegenerateImageToVideo = async (frameData = {}) => {
    if (!frameData?.id) {
      setShowGenericToast({
        message: "Unable to Regenerate the Video",
        status: true,
        type: "danger"
      })
      return;
    }
    else {
      try {
        setCreatingJob(true);

        const payload = {
          jobs: [
            {
              iv_uuid: frameData?.id,
              image_url: frameData?.image_url ?? null,
              last_frame_url: frameData?.last_frame_url ?? null,
              mode: frameData?.mode ?? "std",
              aspect_ratio: frameData?.aspect_ratio ?? "adaptive",
              resolution: frameData?.resolution ?? "720p",
              platform: frameData?.platform ?? "kling",
              duration: frameData?.duration ?? 5,
              prompt: frameData?.prompt ?? null,
              pair_type: frameData?.pair_type ?? null,
              class_type: frameData?.class_type ?? null,
              model_id: frameData?.model_id,
              model_config_id: frameData?.model_config_id
            }
          ]
        }

        const response = await ViewService.createImageToVideosJob(payload);

        const jobId = response?.data?.job_id;

        handleUpdateImageToVideo({ id: frameData?.id, status: "GENERATING", url: null, isSelected: false, polling_job_id: jobId, duration: frameData?.duration ?? 5, actualDuration: frameData?.duration ?? 5, model_id: frameData?.model_id, model_config_id: frameData?.model_config_id });

        pollImageToVideo(jobId, payload?.jobs);

      } catch (error) {

        setShowGenericToast({
          message: error?.response?.data?.message || "Error in Regeneration the Image To Video",
          status: true,
          type: "danger"
        })

      } finally {
        setCreatingJob(false);
        setImageToVideoStates({
          ...ImageToVideoStates,
          frames: ImageToVideoStates?.tab == "bulk" ? [] : [
            {
              frame_id: null,
              image_url: null,
              last_frame_url: null,
              prompt: null,
              sample_video: null,
              aspect_ratio: null,
              platform: "bytedance",
              duration: 5,
              mode: "std",
              resolution: "720p",
              pair_type: null, 
              model_id: "Seeddance1.0Lite",
              model_config_id: "seeddance_1_0_lite_720"
            }
          ],
          type: "add"
        })
      }
    }
  }

  const AddNewDIYOverlayWithMetaData = async (urlType = "image", url = null, type, setAiVideoShootsStates, data = {}, setShowGenericToast, setCurrentTimeSec, setScrollKey) => {
    try {
      let aspect_ratio = "9:16";

      if (urlType == "image") {
        aspect_ratio = await getImageAspectRatioEnum(url);
      }
      else {
        aspect_ratio = await getVideoAspectRatioEnum(url);
      }

      const sizeConfig = getFitOverlaySize(aiVideoShootsStates?.diy?.canvas_ratio || "9:16", aspect_ratio || "9:16");
      let currentData = {
        ...data
      }
      currentData.x = sizeConfig?.x;
      currentData.y = sizeConfig?.y;
      currentData.height = sizeConfig?.height;
      currentData.width = sizeConfig?.width;
      currentData.currentFit = "fit";
      currentData.aspect_ratio = aspect_ratio || "9:16";
      currentData.opacity = 1;
      currentData.rotation = 0;
      currentData.flip = "none";
      if (urlType != "image") {
        currentData.volume = 100;
        currentData.actualDuration = data?.duration || 5;
        currentData.speed = data?.speed || 1;
        currentData.overlayStartTime = 0;
      }

      handleAddOverlayDIY(type, setAiVideoShootsStates, currentData, setShowGenericToast, setCurrentTimeSec, setScrollKey, true);

    } catch (error) {
      console.error("Error in AddNewDIYOverlayWithMetaData:", error);
      setShowGenericToast({
        status: true,
        type: "error",
        message: "Failed to add overlay. Please try again."
      });
    }
  }

  const handleResetVideoTime = () => {
    setMarkerLeft(0);
    setCurrentTimeSec(0);
  }

  const fetchCredits = async () => {
    try {
      setCreditsStates({
        ...creditsStates,
        loading: true
      });
      const response = await ViewService.getStudioAICredits();
      setCreditsStates({
        ...creditsStates,
        loading: false,
        credits: response?.data?.credits
      })
    } catch (error) {
      setCreditsStates({
        ...creditsStates,
        loading: false,
        credits: 0
      })
    }
  };

  const handleResetSpeakingImageStates = ()=>{
    setAiVideoShootsStates((prev)=>({
      ...prev,
      diy: {
        ...prev?.diy,
        global_states: {
          ...getDefaultGlobalStates()
        }
      }
    }))
    setIsGeneratingSpeakingImg(false);
    speakingImgIntervalIdRef.current = null;
    lastGeneratedItemsRef.current = null;
    setSpeakingImgScriptGenerated(false);
    setCharMappingLoader(false);
    characterCounterRef.current = 1;
    setScrollKey(null);
  }

  const handleResetAIVideoShootStates = () => {
    setAiVideoShootsStates({
      job_id: null,
      images: [],
      videos: [],
      selectedTemplate: null,
      templateDuration: 0,
      global_background: null,
      global_text_Configuration: {
        font: null,
        font_style: null,
        font_size: 24,
        color: "#ffffff",
        shadow: false,
      },
      avatars: [],
      avatarDraft: null,
      musics: [],
      brandings: [],
      scripts: [],
      scriptGlobalSubtitle: false,
      texts: [],
      elements: [],
      brolls: [],
      canvas: [],
      shapes: [],
      globalPlatform: "bytedance",
      globalSubtitleConfig: {
        ...Global_Style_Subtitle
      },
      diy: getDefaultDIYStates()
    })
    setCurrentItemKey("media");
    setZoomLevel(1);
    setCurrentSelectedScriptId(null);
    setShowGenericToast({
      status: false,
      type: "success",
      message: ""
    })
    handleResetSpeakingImageStates();
    aiStateRef.current = null;
    setLocalScripts([]);
    setGeneratingScripts(false);
    setPreviewAnimationId(null);
    setEditBlockStates({
      overlayType: null,
      overlayId: null,
      overlayData: null,
      overlayRowIndex: null
    })
    setAIToolKey(null);
    resetCreateAdStates()
  }

  const deselectAllOverlays = () => {
    setAiVideoShootsStates((prev) => ({
      ...prev,
      texts: prev?.texts?.map((textData) => {
        return {
          ...textData,
          isSelected: false
        }
      }),
      elements: prev?.elements?.map((elementData) => {
        return {
          ...elementData,
          isSelected: false
        }
      }),
      brolls: prev?.brolls?.map((brollData) => {
        return {
          ...brollData,
          isSelected: false
        }
      }),
      shapes: prev?.shapes?.map((shapeData) => {
        return {
          ...shapeData,
          isSelected: false
        }
      }),
      canvas: prev?.canvas?.map((canvasData) => {
        if (canvasData?.hasFrame) {
          return {
            ...canvasData,
            frame: {
              ...canvasData?.frame,
              isSelected: false
            }
          }
        }
        else {
          return canvasData
        }
      })
    }))
  }

  const deselectAllOverlaysDIY = () => {
    setAiVideoShootsStates((prev) => {
      let updatedOverlaysData = {};
      for (let overlayKey of Object.keys(prev?.diy?.overlays)) {
        const updatedData = prev?.diy?.overlays[overlayKey]?.data?.map((overlayRow) => {
          const updatedRowData = overlayRow?.data?.map((overlayData) => {
            return {
              ...overlayData,
              isSelected: false
            }
          })
          return {
            ...overlayRow,
            isSelected: false,
            data: updatedRowData
          }
        })
        updatedOverlaysData[overlayKey] = {
          ...prev?.diy?.overlays[overlayKey],
          isSelected: false,
          data: updatedData
        }
      }
      return {
        ...prev,
        diy: {
          ...prev?.diy,
          overlays: {
            ...updatedOverlaysData
          }
        }
      }
    })
    if (ImageToVideoStates?.tab == "single" && ImageToVideoStates?.type == "edit") {
      setImageToVideoStates({
        ...ImageToVideoStates,
        frames: [
          {
            frame_id: null,
            image_url: null,
            last_frame_url: null,
            prompt: null,
            sample_video: null,
            aspect_ratio: null,
            platform: "bytedance",
            duration: 5,
            mode: "std",
            resolution: "720p",
            pair_type: null,
            model_id: "Seeddance1.0Lite",
            model_config_id: "seeddance_1_0_lite_720"
          }
        ],
        type: "add"
      })
    }
    setEditBlockStates({
      overlayType: null,
      overlayId: null,
      overlayData: null,
      overlayRowIndex: null
    })
    setLocalScripts((prev) => {
      return prev?.map((overlay) => ({
        ...overlay,
        isSelected: false
      }))
    })
  }

  const handleAddOverlay = async (data, show_subtitle = false) => {
    if (!isDIYTemplate(aiVideoShootsStates)) {
      const newMediaUploadOverlay = {
        id: data?._id,
        type: "videos",
        width: 1080,
        height: 1920,
        x: data?.url ? 0 : 25,
        y: data?.url ? 0 : 25,
        isSelected: true,
        rotation: 0,
        url: data?.url,
        mediaOverlayType: "speakingImage",
        status: data?.status || "SUCCESS"
      };
      deselectAllOverlays();
      const updatedPreviousOverlay = aiVideoShootsStates?.brolls?.map(
        (brollData) => ({
          ...brollData,
          isSelected: false,
        })
      );
      newMediaUploadOverlay.startTime = 0;
      newMediaUploadOverlay.endTime = aiVideoShootsStates?.templateDuration;
      setAiVideoShootsStates((prev) => ({
        ...prev,
        brolls: [...updatedPreviousOverlay, newMediaUploadOverlay],
      }));
    } else {
      const newSpeakingImageOverlay = {
        id: data?._id,
        width: 1080,
        height: 1920,
        x: data?.url ? 0 : 25,
        y: data?.url ? 0 : 25,
        isSelected: (data?.status == "SUCCESS" || data?.status == "SUCCEEDED") ? true : false,
        rotation: 0,
        url: data?.url,
        show_subtitle: show_subtitle,
        prompt: data?.dialogue || null,
        status: data?.status || "SUCCESS",
        actualDuration: data?.duration ?? 5
      };
      deselectAllOverlaysDIY();
      newSpeakingImageOverlay.duration = data?.duration || 5;
      if (data?.status != "SUCCESS" || data?.status != "SUCCEEDED") {
        const sizeConfig = getFitOverlaySize(aiVideoShootsStates?.diy?.canvas_ratio || "9:16", "9:16");
        let currentData = {
          ...newSpeakingImageOverlay
        }
        currentData.x = sizeConfig?.x;
        currentData.y = sizeConfig?.y;
        currentData.height = sizeConfig?.height;
        currentData.width = sizeConfig?.width;
        currentData.currentFit = "fit";
        currentData.aspect_ratio = "9:16";
        currentData.isSelected = false;
        currentData.flip = "none";
        handleAddOverlayDIY("speaking_image", setAiVideoShootsStates, currentData, setShowGenericToast, setCurrentTimeSec, setScrollKey, true);
      }
      else {
        await AddNewDIYOverlayWithMetaData("video", data?.url, "speaking_image",
          setAiVideoShootsStates,
          newSpeakingImageOverlay,
          setShowGenericToast,
          setCurrentTimeSec,
          setScrollKey
        )
      }
    }
  };

  const handleUpdateOverlay = async (data) => {

    if (data?.status == "SUCCEEDED" || data?.status == "SUCCESS") {
      const aspect_ratio = data?.aspect_ratio || "9:16";
      let aiData = aiVideoShootsStates;
      const sizeConfig = getFitOverlaySize(aiData?.diy?.canvas_ratio || "9:16", aspect_ratio || "9:16");
      let currentData = {
        id: data?._id,
        x: sizeConfig?.x,
        y: sizeConfig?.y,
        height: sizeConfig?.height,
        width: sizeConfig?.width,
        currentFit: "fit",
        aspect_ratio: aspect_ratio || "9:16",
        url: data?.url,
        duration: data?.duration || 8,
        isSelected: false,
        rotation: 0,
        prompt: data?.dialogue || null,
        status: data?.status || "SUCCESS",
        flip: "none",
        actualDuration: data?.duration || 8,
        overlayStartTime: 0
      }
      handleUpdateOverlayDIY("speaking_image", setAiVideoShootsStates, currentData, setShowGenericToast);
    }
    else {
      let currentData = {
        id: data?._id,
        url: null,
        duration: data?.duration || 8,
        isSelected: false,
        rotation: 0,
        prompt: data?.dialogue || null,
        status: "ERROR",
        flip: "none",
        actualDuration: data?.duration || 8,
        overlayStartTime: 0
      }
      handleUpdateOverlayDIY("speaking_image", setAiVideoShootsStates, currentData, setShowGenericToast);
    }

  }

  const cleanPromptText = (text) => {
    if (!text) return null;
    return text.trim().replace(/\n/g, " ").replace(/^"|"$/g, "");
  };

  const updateVeoPromptDataFromJobStatus = (jobStatusList) => {
    const sentItems = lastGeneratedItemsRef.current;
    let responseIndex = 0;

    const updatedData = speakingImageStates?.veoPromptData?.map((item) => {
      if (!sentItems?.includes(item)) {
        return item;
      }

      const job = jobStatusList?.[responseIndex++];

      if (!job) return item;

      return {
        ...item,
        status: job?.status || "SUCCEEDED",
        url: job?.url || null,
        error_occured: job?.error_occured || false,
        sub_job_id: job?._id || null,
        error_msg: job?.error || "",
      };
    });

    handleUpdatedGlobalStates("speakingImageStates", "veoPromptData", updatedData);
  };


  const pollSpeakingJobStatus = async (jobId) => {
    setIsGeneratingSpeakingImg(true);

    const checkStatus = async () => {
      try {
        let params = {
          job_id: jobId,
        };
        const response = await ViewService.fetchSpeakingImageJob(params);
        const status = response?.data?.[0]?.status;
        const jobStatusList = response?.data?.[0]?.job_status;


        if (status === "FINISHED") {
          clearInterval(speakingImgIntervalIdRef.current);
          setIsGeneratingSpeakingImg(false);
          updateVeoPromptDataFromJobStatus(jobStatusList);
          setAiVideoShootsStates((prev) => ({
            ...prev,
            diy: {
              ...prev?.diy,
              overlays: {
                ...prev?.diy?.overlays,
                "speaking_image": {
                  ...prev?.diy?.overlays?.speaking_image,
                  poll_speaking_image: {
                    ai_speaking_image_job_id: prev?.diy?.overlays?.speaking_image?.poll_speaking_image?.ai_speaking_image_job_id,
                    polling: false
                  }
                }
              }
            }
          }))

          if (Array.isArray(jobStatusList) && jobStatusList.length > 0) {
            for (const job of jobStatusList) {
              const videoUrl = job?.url;
              if (videoUrl) {
                await handleUpdateOverlay(job);
              }
            }
          }
          fetchCredits();

          setShowGenericToast({
            status: true,
            type: "success",
            message: "AI speaking image job created successfully.",
          });
        } else if (status === "PARTIALLY_FAILED") {
          clearInterval(speakingImgIntervalIdRef.current);
          setIsGeneratingSpeakingImg(false);
          updateVeoPromptDataFromJobStatus(jobStatusList);
          setAiVideoShootsStates((prev) => ({
            ...prev,
            diy: {
              ...prev?.diy,
              overlays: {
                ...prev?.diy?.overlays,
                "speaking_image": {
                  ...prev?.diy?.overlays?.speaking_image,
                  poll_speaking_image: {
                    ai_speaking_image_job_id: prev?.diy?.overlays?.speaking_image?.poll_speaking_image?.ai_speaking_image_job_id,
                    polling: false
                  }
                }
              }
            }
          }))
          if (Array.isArray(jobStatusList) && jobStatusList.length > 0) {
            for (const job of jobStatusList) {
              if (job?.status === "SUCCEEDED" && job?.url) {
                await handleUpdateOverlay(job);
              } else {
                await handleUpdateOverlay({ url: null, duration: job?.duration, status: "ERROR", dialogue: job?.dialogue, _id: job?._id, show_subtitle: false });
              }
            }
          }
          fetchCredits();
          setShowGenericToast({
            status: true,
            type: "danger",
            message: "Some videos generated successfully, but others failed.",
          });
        } else if (status === "FAILED") {
          clearInterval(speakingImgIntervalIdRef.current);
          // handleResetOverlay("speaking_image", true, setAiVideoShootsStates);
          setIsGeneratingSpeakingImg(false);
          updateVeoPromptDataFromJobStatus(jobStatusList);
          setAiVideoShootsStates((prev) => ({
            ...prev,
            diy: {
              ...prev?.diy,
              overlays: {
                ...prev?.diy?.overlays,
                "speaking_image": {
                  ...prev?.diy?.overlays?.speaking_image,
                  poll_speaking_image: {
                    ai_speaking_image_job_id: prev?.diy?.overlays?.speaking_image?.poll_speaking_image?.ai_speaking_image_job_id,
                    polling: false
                  }
                }
              }
            }
          }))
          for (const job of jobStatusList) {
            await handleUpdateOverlay({ url: null, duration: job?.duration, status: "ERROR", dialouge: job?.dialogue, _id: job?._id, show_subtitle: false });
          }

          setShowGenericToast({
            status: true,
            type: "danger",
            message: "Failed to create speaking image video.",
          });
        }
      } catch (error) {
        console.error("Error checking job status:", error);
        clearInterval(speakingImgIntervalIdRef.current);
        setAiVideoShootsStates((prev) => ({
          ...prev,
          diy: {
            ...prev?.diy,
            overlays: {
              ...prev?.diy?.overlays,
              "speaking_image": {
                ...prev?.diy?.overlays?.speaking_image,
                poll_speaking_image: {
                  ai_speaking_image_job_id: prev?.diy?.overlays?.speaking_image?.poll_speaking_image?.ai_speaking_image_job_id,
                  polling: false
                }
              }
            }
          }
        }))
        setIsGeneratingSpeakingImg(false);
        setShowGenericToast({
          status: true,
          type: "danger",
          message: "Failed to create speaking image video.",
        });
      }
    };
    await checkStatus();
    speakingImgIntervalIdRef.current = setInterval(checkStatus, 15000);
  };

  const handleGenerateSpeakingImage = async () => {
    try {
      setIsGeneratingSpeakingImg(true);

      if (!speakingImageStates?.uploadedImages?.length || speakingImageStates?.selectedImage === null) {
        setShowGenericToast({
          status: true,
          type: "danger",
          message: "Please upload and select an image first.",
        });
        setIsGeneratingSpeakingImg(false);
        return;
      }

      if (speakingImageStates?.platform === "omnihuman") {
        if (!speakingImageStates?.characters?.length) {
          setShowGenericToast({
            status: true,
            type: "danger",
            message: "Please create at least one character.",
          });
          setIsGeneratingSpeakingImg(false);
          return;
        }
      } else if (speakingImageStates?.platform === "veo") {
        if (!speakingImageStates?.veoPromptData || !speakingImageStates?.veoPromptData?.length) {
          setShowGenericToast({
            status: true,
            type: "danger",
            message:
              "Please add at least one prompt entry to create the video.",
          });
          setIsGeneratingSpeakingImg(false);
          return;
        }

        // const hasIncompleteData = veoPromptData.some((item, index) => {
        //   return (
        //     !item.prompt ||
        //     !item.image_url ||
        //     !item.duration ||
        //     item.prompt.trim() === "" ||
        //     item.image_url.trim() === "" ||
        //     Number(item.duration) <= 0
        //   );
        // });

        // if (hasIncompleteData) {
        //   setShowGenericToast({
        //     status: true,
        //     type: "danger",
        //     message:
        //       "Please fill in all fields (image, prompt, and duration) for every prompt before creating the video.",
        //   });
        //   setIsGeneratingSpeakingImg(false);
        //   return;
        // }
      }

      const imageUrl = speakingImageStates?.platform === "kling" ? speakingImageStates?.uploadedImages?.[0] : speakingImageStates?.veoPromptData?.[0]?.image_url;

      let payload = {
        image_url: imageUrl,
        platform: speakingImageStates?.platform,
      };

      const newItems = speakingImageStates?.veoPromptData?.filter((item) => !item?.sub_job_id);

      if (speakingImageStates?.platform === "omnihuman") {

        payload.speaking_image_jobs = speakingImageStates?.characters?.map((char) => ({
          audio_url: char?.audio_url,
          mask_image: char?.mask_url,
          script: char?.script,
          voice_id: char?.voice_id,
        }));

        payload.prompt = cleanPromptText(speakingImageStates?.scenePrompt);

      } else if (speakingImageStates?.platform === "veo") {

        if (!newItems.length) {
          setShowGenericToast({
            status: true,
            type: "danger",
            message: "No new prompts to generate.",
          });
          setIsGeneratingSpeakingImg(false);
          return;
        }

        payload.speaking_image_jobs = newItems?.map((prompt) => ({
          image_url: prompt?.image_url || prompt?.start_image,
          last_frame_url: prompt?.end_image,
          duration: prompt?.duration,
          dialogue: cleanPromptText(prompt?.dialogue),
          aspect_ratio: "9:16",
          character_description: prompt?.character_description,
          sfx: prompt?.sfx,
          sfx_prompt: prompt?.is_sfx ? prompt?.sfx_prompt : null,
          negative_prompt: prompt?.negative_prompt,
          veo_prompt: prompt?.is_video_prompt ? prompt?.video_prompt : null,
          continuity: true,
          bridge_block: prompt?.bridge_block ? true : false,
          mode: prompt?.mode,
          platform: prompt?.model,
          resolution: prompt?.resolution,

        }));

        payload.last_frame_url = null;
        payload.prompt = null;
      }
      lastGeneratedItemsRef.current = newItems;

      const response = await ViewService.generateSpeakingVideo(payload);
      const id = response?.data?._id;
      setSpeakingImgJobId(id);

      const responseJob = response?.data?.job_status;

      responseJob?.map((prompt, index) => {
        handleAddOverlay({ url: null, duration: prompt?.duration, status: "GENERATING", _id: prompt?._id }, newItems[index]?.show_subtitle || false);
      })

      if (id) {
        setAiVideoShootsStates((prev) => ({
          ...prev,
          diy: {
            ...prev?.diy,
            overlays: {
              ...prev?.diy?.overlays,
              "speaking_image": {
                ...prev?.diy?.overlays?.speaking_image,
                poll_speaking_image: {
                  ai_speaking_image_job_id: id,
                  polling: true
                }
              }
            }
          }
        }))
        pollSpeakingJobStatus(id);
      } else {
        setShowGenericToast({
          status: true,
          type: "danger",
          message: "No job ID returned from API",
        });
        setIsGeneratingSpeakingImg(false);
      }
    } catch (error) {
      console.error("Error generating speaking image:", error);
      setShowGenericToast({
        status: true,
        type: "danger",
        message: "Failed to create speaking image video",
      });
      setAiVideoShootsStates((prev) => ({
        ...prev,
        diy: {
          ...prev?.diy,
          overlays: {
            ...prev?.diy?.overlays,
            "speaking_image": {
              ...prev?.diy?.overlays?.speaking_image,
              poll_speaking_image: {
                ai_speaking_image_job_id: prev?.diy?.overlays?.speaking_image?.poll_speaking_image?.ai_speaking_image_job_id,
                polling: false
              }
            }
          }
        }
      }))
      setIsGeneratingSpeakingImg(false);
    }
  };

  const handleRegenerateSpeakingImage = async (scene) => {
    try {
      let data = {
        job_id: speakingImgJobId,
        regen_array: [
          {
            sub_job_id: scene?.sub_job_id,
            image_url: scene?.image_url,
            aspect_ratio: "9:16",
            dialogue: scene?.dialogue,
            duration: scene?.duration,
            sfx: scene?.sfx,
            sfx_prompt: scene?.is_sfx ? scene?.sfx_prompt : null,
            negative_prompt: scene?.negative_prompt,
            veo_prompt: scene?.is_video_prompt ? scene?.video_prompt : null,
            continuity: true,
            bridge_block: scene?.bridge_block ? true : false,
            // character_position: scene?.character_position,
            character_description: scene?.character_description,
          },
        ],
      };

      await ViewService.reGenerateSpeakingImage(data);
      handleUpdateOverlay({ url: null, duration: scene?.duration, status: "GENERATING", dialogue: scene?.dialogue, _id: scene?.sub_job_id, show_subtitle: scene?.show_subtitle || false });
      setAiVideoShootsStates((prev) => ({
        ...prev,
        diy: {
          ...prev?.diy,
          overlays: {
            ...prev?.diy?.overlays,
            "speaking_image": {
              ...prev?.diy?.overlays?.speaking_image,
              poll_speaking_image: {
                ai_speaking_image_job_id: speakingImgJobId,
                polling: true
              }
            }
          }
        }
      }))
      pollSpeakingJobStatus(speakingImgJobId);
    } catch (error) {
      setShowGenericToast({
        status: true,
        type: "danger",
        message:
          error?.response?.data?.message ||
          "Failed to regenerate the video.",
      });
      setAiVideoShootsStates((prev) => ({
        ...prev,
        diy: {
          ...prev?.diy,
          overlays: {
            ...prev?.diy?.overlays,
            "speaking_image": {
              ...prev?.diy?.overlays?.speaking_image,
              poll_speaking_image: {
                ai_speaking_image_job_id: prev?.diy?.overlays?.speaking_image?.poll_speaking_image?.ai_speaking_image_job_id,
                polling: false
              }
            }
          }
        }
      }))
    }
  };

  const stopSpeakingImgAPIPolling = () => {
    if (speakingImgIntervalIdRef.current) {
      clearInterval(speakingImgIntervalIdRef.current);
    }
  };

  const handleVeoCharacterMapping = async (imageUrls) => {
    setCharMappingLoader(true);
    console.log("mapping", imageUrls)
    try {
      const requiredParams = {
        image_urls: imageUrls,
      };

      const response = await ViewService.veoCharacterMapping(requiredParams);
      const images = response?.data?.images || [];

      const newMappedCharacters = images.map((img) => ({
        imageIndex: img.imageIndex,
        imageUrl: img.imageUrl,
        faces: img.faces.map((face) => ({
          ...face,
          name: `Character ${characterCounterRef.current++}`,
          isEditing: false,
          visible: true,
          character_id: face?.characterId,
        })),
      }));
      setVeoCharacters([...veoCharacters, ...newMappedCharacters]);
    } catch (error) {
      console.log("Error", error);
      setShowGenericToast({
        status: true,
        type: "danger",
        message: error?.response?.data?.message || "Something went wrong.",
      });
    } finally {
      setCharMappingLoader(false);
    }
  };

  const pollKlingSpeakingJobStatus = async (jobId) => {
    setIsGeneratingSpeakingImg(true);

    const checkStatus = async () => {
      try {
        let params = {
          job_id: jobId,
        };
        const response = await ViewService.fetchSpeakingImageJob(params);
        const status = response?.data?.[0]?.status;
        const jobStatusList = response?.data?.[0]?.talking_actor_job;


        if (status === "FINISHED") {
          clearInterval(speakingImgIntervalIdRef.current);
          setIsGeneratingSpeakingImg(false);
          console.log("jobStatusList?.audio_duration", jobStatusList);
          handleUpdateOverlay({ url: jobStatusList?.url, duration: jobStatusList?.video_duration, status: "SUCCEEDED", dialogue: jobStatusList?.script, _id: jobStatusList?._id, show_subtitle: false })
          fetchCredits();

          setShowGenericToast({
            status: true,
            type: "success",
            message: "AI speaking image job created successfully.",
          });

        } else if (status === "FAILED") {
          clearInterval(speakingImgIntervalIdRef.current);
          setIsGeneratingSpeakingImg(false);
          handleUpdateOverlay({ url: null, duration: 8, status: "ERROR", dialogue: jobStatusList?.script, _id: jobStatusList?._id, show_subtitle: false })
          setShowGenericToast({
            status: true,
            type: "danger",
            message: "Failed to create speaking image video.",
          });
        }
      } catch (error) {
        console.error("Error checking job status:", error);
        clearInterval(speakingImgIntervalIdRef.current);
        setIsGeneratingSpeakingImg(false);
        setShowGenericToast({
          status: true,
          type: "danger",
          message: "Failed to create speaking image video.",
        });
      }
    };
    await checkStatus();
    speakingImgIntervalIdRef.current = setInterval(checkStatus, 15000);
  };


  const handleGenerateKlingSpeakingImage = async () => {
    try {
      setIsGeneratingSpeakingImg(true);
      let payload = {
        image_url: speakingImageStates?.uploadedImages?.[0],
        platform: speakingImageStates?.platform,
        script: cleanPromptText(klingScript),
        voice_id: selectedVoice?.voice_id
      };

      const response = await ViewService.generateSpeakingVideo(payload);
      const id = response?.data?._id;
      setSpeakingImgJobId(id);

      const responseJob = response?.data?.talking_actor_job;
      console.log("responseJob", responseJob);


      handleAddOverlay({ url: null, duration: 8, status: "GENERATING", _id: responseJob?._id }, false);


      if (id) {
        pollKlingSpeakingJobStatus(id);
      } else {
        setShowGenericToast({
          status: true,
          type: "danger",
          message: "No job ID returned from API",
        });
        setIsGeneratingSpeakingImg(false);
      }
    } catch (error) {
      console.error("Error generating speaking image:", error);
      setShowGenericToast({
        status: true,
        type: "danger",
        message: "Failed to create speaking image video",
      });
      setIsGeneratingSpeakingImg(false);
    }

  }


  return (
    <AIVideoEditorContext.Provider value={{ markerLeft, setMarkerLeft, currentTimeSec, setCurrentTimeSec, handleResetVideoTime, aiVideoShootsStates, setAiVideoShootsStates, handleResetAIVideoShootStates, showGenericToast, setShowGenericToast, deselectAllOverlays, currentItemKey, setCurrentItemKey, zoomLevel, setZoomLevel, currentSelectedScriptId, setCurrentSelectedScriptId, avatarSwitchMode, setAvatarSwitchMode, fetchCredits, creditsStates, deselectAllOverlaysDIY, speakingImageStates, scrollKey, setScrollKey, platform, veoCharacters, setVeoCharacters, speakingImagePrompt, setSpeakingImagePrompt, handleGenerateSpeakingImage, handleRegenerateSpeakingImage, isGeneratingSpeakingImage, stopSpeakingImgAPIPolling, AddNewDIYOverlayWithMetaData, aiStateRef, speakingImgScriptGenearted, setSpeakingImgScriptGenerated, speakingImgGeneratedScene, setSpeakingImgGeneratedScene, showCreateSpeakingImgBtn, setShowCreateSpeakingImgBtn, handleVeoCharacterMapping, charMappingLoader, setCharMappingLoader, previewAnimationId, setPreviewAnimationId, localScripts, setLocalScripts, generatingScripts, stopScriptPolling, handleGenerateScriptsAudio, handleRegenerateScript, handleUpdateScriptsDIY, handleUpdateLocalScriptsDIY, creatingJob, stopAllImageToVideoPolling, AddImageToVideos, handleRegenerateImageToVideo, ImageToVideoStates, setImageToVideoStates, editBlockStates, setEditBlockStates, selectedVoice, setSelectedVoice, klingPrompt, setKlingPropmt, klingScript, setKlingScript, handleGenerateKlingSpeakingImage, getFonts, fonts, setFonts, aiToolKey, setAIToolKey, createAdStates, resetCreateAdStates, povStates, handleUpdatePOVStates, generatingPOV, povIntervalRef, stopPOVPolling, handleGeneratePOVvideo, stopPOVPolling, handleAddPovOverlayBlock, handleAddPovOverlayBlock, generating, generatedScenesStates, handleGenerateScriptsCreateAd, setGeneratedScenesStates, generatingCreateAd, stopCreateAdPolling, handleGenerateCreateAdvideo, pollSpeakingJobStatus, getPOVVideoJobStatus, handleRegeneratePOVVideo, handleUpdatedGlobalStates, handleUpdateCreateAdStates, fetchI2VModels, modelsData, cloneAdStates, setCloneAdStates,  generatingCloneAdScripts, generatedScenesStatesCloneAd, setGeneratedScenesStatesCloneAd, handleGenerateScriptsCloneAd, resetCloneAdStates, generatingCloneAd, stopCloneAdPolling, handleGenerateCloneAdvideo}}>
      {children}
    </AIVideoEditorContext.Provider>
  );
}

export default AIVideoEditorProvider